module.exports = __webpack_public_path__ + "img/fecha.4fbc7ffb.svg";